import { render, staticRenderFns } from "./AccountsReceivableDetailsDialog.vue?vue&type=template&id=79e5fae8"
import script from "./AccountsReceivableDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./AccountsReceivableDetailsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports